import { IncomingMessage } from 'http';
import { APP_LOCALE, APP_TENANT, GRAPH_ENDPOINT } from '@99designs/design-services-common';
import { createSSRApolloClient } from './apolloClient';

export function designServicesApolloClient(req: IncomingMessage, locale: string) {
    const referer = req.headers.host || '';
    return createSSRApolloClient(req, GRAPH_ENDPOINT, {
        headers: {
            locale: locale ?? APP_LOCALE,
            tenant: APP_TENANT,
            referer,
        },
    });
}
